import Axios from 'axios';
import React, { useEffect, useState } from 'react'
import {IoIosArrowForward} from 'react-icons/io'
import { Link } from 'react-router-dom';
import Header from '../components/Header';

export const PList = ({ match, ...props }) => {
    const { id } = match.params;
    const [loading,setLoading]=useState(false)
    const [data, setData] = useState({
        page: 1,
        cate: {
            name: ''
        },
        pageCount:0
    })
    const [list, setList] = useState([])
    const take = 30;
    const loadData = async (page) => {
        setLoading(true);
        const res = await Axios.post(`/api/pinfo/slist/${id}`, {
            page,
            take
        })
        setData(res.data);
        setList([...list, ...res.data.list])
        setLoading(false)


    }
    useEffect(() => {
        loadData(1);
    }, [id])
    const buildList = () => {
        return list.map(it => (
            <li key={it.id} className='pinfo-item-wrap'>
                <div className='texts-wrap'>
                    <Link to={`/pdetail/${it.id}`} className='ptitle-link'>
                    {it.title}
                    </Link>
                    <br/>
                    <span className='comname-span'>{it.comName}</span>
                </div>
                <div>
                    <IoIosArrowForward size={30}  color='#ddd' />

                </div>
            </li>
        ))
    }
    const onLoadMore=()=>{
        if(data.page<data.pageCount){
            loadData(data.page+1);
        }
    }
    const buildLoadMore=()=>{
        if(!loading && data.page < data.pageCount){
            return(

            <div className='mt-2 load-more-wrap'>
                <a onClick={onLoadMore}>加载更多</a>
            </div>
            )
        }
        else{
            return null;
        }
    }
    return (
        <div>
            <Header title={data.cate.name} />
            <ul className='list-unstyled p-2'>

                {buildList()}
            </ul>
            {buildLoadMore()}
        </div>
    )
}
